export enum WelcomeCallSortableFieldEnum {
  EFFECTIVE_DATE = 'effectiveDate',
  WATCH_DELIVERED_DATE = 'watchDeliveredDate',
  CREATED_AT = 'createdAt',
}
